import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import {V1ProjectPlanPhaseMilestoneIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";


class ProjectPlanPhaseMilestoneLookupEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();
        let primaryIntegrationComponent = "ProjectPlanPhaseMilestone";

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.ProjectPlanPhaseMilestone-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.ProjectPlanPhaseMilestone-001";

        let QBE = {
            "PlatformMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                [primaryIntegrationComponent]: {
                    '_attributes': {
                        'limit': pageSize,
                        'sort': this.getFormattedSortSpecification(),
                        'offset': (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": []
                                }
                            }
                        ]
                    }
                }
            }
        }

        if (this.getSearchSpecification() !== null) {
            let keys = Object.keys(this.getSearchSpecification());
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];

                QBE.PlatformMessage[primaryIntegrationComponent].QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": this.getSearchSpecification()[key],
                    "Operator": "EQUAL"
                })
            }
        }

        AxiosFoundationAPI({
            method: "GET",
            url: "t1/v1/project_plan_phase_milestones",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

}

export default ProjectPlanPhaseMilestoneLookupEnterpriseComponent;